import { Feature, EventEmitter, BuiltinUIEvent } from '@tencent/workbench';
import { Subscription } from 'rxjs';
import { SLIDE_ADAPTER } from '../../editor-adpater/mobile-adapter';
import BaseMobileContextMenuFeature from '@src/framework/workbench/common/feature/base-mobile-context-feature';

@Feature({
    adapters: [SLIDE_ADAPTER],
})
export default class ContextMenuDismissFeature extends BaseMobileContextMenuFeature {
    private listener: Subscription | undefined;
    public constructor(private eventEmitter: EventEmitter) {
        super();
    }

    public $onEditorOpen() {
        // WORKBENCH_MOBILE_TOGGLE
        this.listener = this.eventEmitter.listen(
            BuiltinUIEvent.AfterContextMenuDismissed,
            this.handleRemove,
        );
    }

    public $onEditorClose() {
        this.listener?.unsubscribe();
    }

    private handleRemove = () => {
        this.getAppServices().viewableServiceLayer
            .mobileRightMenuMananger.promise().then((mobileRightMenuMananger) => {
                mobileRightMenuMananger.removeEvents();
            });
    };
}
